import { Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Loader from './Loader';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedUserTypes: ('member' | 'organizer')[];
}

export default function ProtectedRoute({ children, allowedUserTypes }: ProtectedRouteProps) {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const verifyAuth = async () => {
      const userType = localStorage.getItem('userType');
      const authToken = localStorage.getItem('authToken');
      const userData = localStorage.getItem('userData');

      if (!userType || !authToken || !userData || !allowedUserTypes.includes(userType as any)) {
        setIsAuthenticated(false);
        return;
      }

      try {
        const parsedData = JSON.parse(userData);
        const [storedUserType, userId] = atob(authToken).split(':');

        // Verificar que el tipo de usuario coincida
        if (storedUserType !== userType) {
          setIsAuthenticated(false);
          return;
        }

        // Verificar que el ID coincida con los datos almacenados
        if (parsedData.user?.id !== userId) {
          setIsAuthenticated(false);
          return;
        }

        setIsAuthenticated(true);
      } catch (error) {
        setIsAuthenticated(false);
      }
    };

    verifyAuth();
  }, [allowedUserTypes]);

  if (isAuthenticated === null) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    // Limpiar localStorage y redirigir al login
    localStorage.clear();
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}